import { JournalStockField } from './types'

export interface DefaultBookingJournalProduct {
  productId: number
  fieldKey: JournalStockField
  label: string
}

/** Mirrors backend EON_BOOKING_JOURNAL_DEFAULT_PRODUCTS / product map. */
export const DEFAULT_BOOKING_JOURNAL_PRODUCTS: DefaultBookingJournalProduct[] = [
  { productId: 10000003, fieldKey: 'chicken', label: 'Chicken' },
  { productId: 10000002, fieldKey: 'beef', label: 'Beef' },
  { productId: 10000004, fieldKey: 'pork', label: 'Pork' },
  { productId: 10001142, fieldKey: 'groundBeef', label: 'Ground Beef' },
  { productId: 10000054, fieldKey: 'avocado', label: 'Avocado' },
  { productId: 10000064, fieldKey: 'tomato', label: 'Tomato' }
]

export const DEFAULT_BOOKING_JOURNAL_PRODUCT_IDS = DEFAULT_BOOKING_JOURNAL_PRODUCTS.map(p => p.productId)

const DEFAULT_PRODUCT_ID_SET = new Set(DEFAULT_BOOKING_JOURNAL_PRODUCT_IDS)

/** Pinned Daily Stock rows (Add row) — unique positive ints, never the default six. */
export function normalizeDailyStockPinnedProductIds(productIds: readonly unknown[] | null | undefined): number[] {
  if (!productIds?.length) return []

  const seen = new Set<number>()

  return productIds
    .map(id => Number(id))
    .filter(id => {
      if (!Number.isInteger(id) || id <= 0 || DEFAULT_PRODUCT_ID_SET.has(id)) {
        return false
      }
      if (seen.has(id)) return false
      seen.add(id)

      return true
    })
}
